import { Component, ViewChild, OnInit, Injectable } from '@angular/core';
import { FixedTopProgressBarComponent } from '../component/fixed-top-progress-bar/fixed-top-progress-bar.component';
import { EmailConfirmedComponent } from './email-confirmed/email-confirmed.component';
import { RouterOutlet, ActivatedRoute } from '@angular/router';
import { ErrorViewComponent } from '../component/error-view/error-view.component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { LanguageService } from '../service/language.service';
import { Language } from '../model/language';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {
  @ViewChild(FixedTopProgressBarComponent, { static: true }) progressBar: FixedTopProgressBarComponent;

  @ViewChild('routerOutlet', { static: true }) routerOutlet: RouterOutlet;
  containerIsLarge = false;

  languageForm: FormGroup;
  message: string;
  currentLanguage: Language;

  constructor(
    public languageService: LanguageService,
    public fb: FormBuilder,
    public translate: TranslateService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.initForm();

    this.message = this.route.snapshot.queryParams['message'];

    // languageService.availableLanguages is populated asynchronously after
    // SystemService.countries resolves, so poll until we can resolve the
    // current lang code into a Language object. Then keep it in sync with
    // translate.onLangChange.
    const resolveLang = () => {
      const lang = this.languageService.getLanguage(this.translate.currentLang);
      if (lang) {
        this.currentLanguage = lang;
      } else {
        setTimeout(resolveLang, 100);
      }
    };
    resolveLang();
    this.translate.onLangChange.subscribe(event => {
      this.currentLanguage = this.languageService.getLanguage(event.lang);
    });
  }

  private initForm() {
    this.languageForm = this.fb.group({
      language: [this.translate.currentLang]
    });
  }

  clearMessage() {
    this.message = undefined;
  }
  
  onActivateOutlet(event): void{
    this.containerIsLarge =
      this.routerOutlet.component instanceof EmailConfirmedComponent ||
      this.routerOutlet.component instanceof ErrorViewComponent;

  }
}
